var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-panel",
    [
      _c("template", { slot: "main-panel-links" }, [
        _c(
          "div",
          { staticClass: "navi-link mb-2" },
          [
            _c("router-link", { attrs: { to: { name: "home" } } }, [
              _vm._v("\n        Home "),
              _c("i", { staticClass: "fas fa-home" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navi-link" },
          [
            _c("router-link", { attrs: { to: { name: "client" } } }, [
              _vm._v("\n        Publisher Selection "),
              _c("i", { staticClass: "fas fa-user" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navi-link" },
          [
            _c("router-link", { attrs: { to: { name: "search" } } }, [
              _vm._v("\n        Search "),
              _c("i", { staticClass: "fas fa-search" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isConfigurationActive || _vm.isAlternativePaymentActive,
                expression:
                  "isConfigurationActive || isAlternativePaymentActive"
              }
            ],
            staticClass: "navi-link"
          },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "configuration",
                    params: { clientId: _vm.clientSelectedCode }
                  }
                }
              },
              [
                _vm._v("\n        Configurations "),
                _c("i", { staticClass: "fas fa-cog fa-fw" })
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isConfigurationActive || _vm.isAlternativePaymentActive,
                expression:
                  "isConfigurationActive || isAlternativePaymentActive"
              }
            ],
            staticClass: "navi-link"
          },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "alternativePayments",
                    params: { clientId: _vm.clientSelectedCode }
                  }
                }
              },
              [
                _vm._v("\n        Alternative Payments "),
                _c("i", { staticClass: "fa fa-file" })
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navi-link" },
          [
            _c("router-link", { attrs: { to: { name: "settings" } } }, [
              _vm._v("\n        Settings "),
              _c("i", { staticClass: "fa fa-cog" })
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "main-panel-content" }, [
        _c("div", { staticClass: "main-content" }, [_c("router-view")], 1)
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }